import type { RouteObject } from "react-router-dom";

export const redoUsesRedoRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Redo Uses Redo" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { ProductsPage } = await import("./products");
          return { Component: ProductsPage };
        },
      },
    ],
  },
];
